import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { apiGetPayments } from '../../../api/user';

import Card from '../../../components/Card';
import PaymentTable from '../../../components/PaymentTable';
import { routes } from '../..';

class PaymentsList extends Component {
  static propTypes = {
    history: PropTypes.object,
  };

  state = {
    loading: true,
    transactions: [],
  };

  componentDidMount() {
    apiGetPayments()
      .then(({ data }) => this.setState({ loading: false, transactions: data }))
      .then(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) return <noscript />;
    const { transactions } = this.state;
    const { history } = this.props;

    return (
      <div>
        <Card>
          <Card.Header compact>Payments</Card.Header>
          <Card.Body>
            {transactions.length > 0
              ? 'Below is a list of all of your payments.'
              : 'You have not made any payments. Once you do, they will show up here.'}
          </Card.Body>
        </Card>
        <PaymentTable
          transactions={transactions}
          onClickReceipt={(id) => history.push(routes.payments.receiptBuilder(id))}
        />
      </div>
    );
  }
}

export default withRouter(PaymentsList);
